export type SupplierLabelKey =
  | "capabilities.contextRead"
  | "operations.create"
  | "operations.update"
  | "operations.contactCreate"
  | "operations.contactUpdate"
  | "operations.contactDeactivate"
  | "operations.accessInvite"
  | "operations.accessRevoke"
  | "states.inProgress"
  | "states.completed"
  | "states.failed"
  | "states.reconciling"
  | "unknown";

const labels: Record<string, SupplierLabelKey> = {
  "supplier.context.read": "capabilities.contextRead",
  "supplier.create": "operations.create",
  "supplier.update": "operations.update",
  "supplier.contact.create": "operations.contactCreate",
  "supplier.contact.update": "operations.contactUpdate",
  "supplier.contact.deactivate": "operations.contactDeactivate",
  "supplier.access.invite": "operations.accessInvite",
  "supplier.access.revoke": "operations.accessRevoke",
  inprogress: "states.inProgress",
  completed: "states.completed",
  failed: "states.failed",
  reconciling: "states.reconciling",
};

export function supplierStateLabel(value: string): SupplierLabelKey {
  return labels[value] ?? labels[value.toLowerCase()] ?? "unknown";
}
